// Polyfills
import 'es6-promise/auto';
import 'babel-polyfill';
import RISON from 'rison';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import App from './App';
import store from './store';
import router from './router';
import { sync } from 'vuex-router-sync';
import VuesticPlugin from 'vuestic-theme/vuestic-plugin';
import VueResource from 'vue-resource';
import filters from '@/services/filters';
import moment from 'moment';
import 'moment-duration-format';
import './i18n';
import urlParams from '@/services/urlParams';
import * as VueGoogleMaps from 'vue2-google-maps';

window.RISON = RISON;

// bootstrap config

Vue.use(VuesticPlugin);

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});
Vue.use(VueResource);
Vue.url.params = urlParams;

Vue.use(filters);

Vue.use(VueGoogleMaps, {
  load: {
    key: store.getters.config.googleMaps.apiKey,
    libraries: 'places',
  },
});

sync(store, router);

const mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch('toggleSidebar', true);
  } else {
    store.dispatch('toggleSidebar', false);
  }
};

const redirectLogin = () => {
  let q = new URLSearchParams();
  q.append('role', store.getters.config.allowedRoles.join(','));
  q.append('redirect', window.location.href);
  window.location = store.getters.api.host + store.getters.api.sso + '?' + q.toString();
};

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true);
  if (to.meta && to.meta.auth) {
    if (!store.getters.role) {
      return redirectLogin();
    }
    if ((typeof to.meta.auth === 'string' || Array.isArray(to.meta.auth)) &&
      ![].concat(to.meta.auth).includes(store.getters.role)) {
      return next('/park/bays');
    }
  }
  next();
});

router.afterEach((to, from) => {
  mediaHandler();
  store.state.app.initialized = true;
  store.commit('setLoading', false);
});

Vue.http.options.credentials = true;
Object.defineProperty(Vue.http.options, 'root', {
  get: () => store.getters.api.host + store.getters.api.base,
  enumerable: true,
  configurable: true,
});

// redirect login before start

const updateLoginStatus = async function () {
  let data = (await Vue.http.get('sso/checkLoginStatus')).data;
  if (data.profile && !store.getters.config.allowedRoles.includes(data.profile.role)) {
    throw new Error();
  }
  store.commit('setUser', data);
};

(async () => {
  try {
    await updateLoginStatus();
  } catch (e) {
    redirectLogin();
    return;
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    watch: {
      '$store.state.i18n.locale': {
        immediate: true,
        handler (v) {
          moment.locale([v, this.$store.state.i18n.fallback].map(x => x === 'zh' ? 'zh-hk' : x));
        },
      },
      '$store.state.i18n.fallback' (v) {
        moment.locale([this.$store.state.i18n.locale, v].map(x => x === 'zh' ? 'zh-hk' : x));
      },
    },
  });

  setInterval(async () => {
    try {
      await updateLoginStatus();
    } catch (e) {
      if (e.status === 0) {
        return; // no response, ignore
      }
      alert(Vue.i18n.translate('msg.session_timeout'));
      redirectLogin();
    }
  }, 1000 * 60 * 10); // check every 10 min
})();



// WEBPACK FOOTER //
// ./src/main.js